import React from 'react';
import RoleContainer from '@src/containers/Role';

const Role = () => <RoleContainer />;

export default Role;
